import React from 'react';
import { Award } from 'lucide-react';
import { InstagramIcon } from 'lucide-react';
export function AuthoritySection() {
  return <section className="w-full bg-gray-900 py-16 px-4 border-y-8 border-yellow-400" data-id="element-16">
      <div className="max-w-3xl mx-auto text-center" data-id="element-17">
        <p className="text-xl text-gray-300 mb-2" data-id="element-18">
          Este material fue creado por
        </p>

        <div className="flex justify-center mb-6" data-id="element-19">
          <img src="https://cdn.magicpatterns.com/uploads/62XJj6PoseJKiBGjd3Cjyt/16e6b0f5-36b3-43fe-b260-c609d4b4c5ec.jpg" alt="Sabrina Bravo" className="w-36 h-36 md:w-44 md:h-44 rounded-full object-cover border-4 border-yellow-400 shadow-2xl" data-id="element-20" />
        </div>

        <h3 className="text-4xl md:text-5xl font-black text-white mb-2" data-id="element-21">
          Sabrina Bravo
        </h3>
        <p className="text-2xl text-yellow-400 font-medium mb-4" data-id="element-22">
          Psicopedagoga — Argentina
        </p>

        <p className="inline-flex items-center gap-2 text-pink-400 text-lg font-semibold mb-10" data-id="element-23">
          <InstagramIcon className="w-5 h-5" data-id="element-24" />
          @psicope_encasa1
        </p>

        <div className="bg-gray-800 rounded-2xl p-8 border border-gray-700 text-left space-y-6 shadow-2xl" data-id="element-25">
          <p className="text-lg md:text-xl text-gray-200 leading-relaxed" data-id="element-26">
            Este kit fue desarrollado para acercar herramientas psicopedagógicas
            a las familias y ayudar a los padres a comprender mejor el proceso
            de aprendizaje de sus hijos.
          </p>
        </div>
      </div>
    </section>;
}